export default {
  MY_HOME: `Ma Page d'Accueil`,
  MY_SCHEDULE: `Mon horaire`,
  VIEW_YOUR_CURRENT_SCHEDULE: `Voir votre horaire actuel`,
  VIEW_MY_SCHEDULE: `Voir mon horaire`,
  MY_AVAILABILITY: `Mes disponibilités`,
  MANAGE_AVAILABILITY_FUTURE_SHIFTS: `Gérer vos disponibilités pour les quarts de travail futurs`,
  CREATE_AVAILABILITY: `Créer une disponibilité`,
  CHANGE_AND_VIEW_MY_AVAILABILITY: `Gérer mes disponibilités`,
  MY_ATTENDANCE: `Mes absences`,
  MANAGE_YOUR_REQUESTS: `Gérer vos requêtes d'absence, de retard, ou de départ hâtif`,
  CREATE_ATTENDANCE_REQUEST: `Créer une requête`,
  VIEW_MY_ATTENDANCE_HISTORY: `Voir mes requêtes d'absence`,
  MY_TIME_OFF: `Mes congés`,
  REQUEST_VIEW_TIME_OFF: `Gérer vos requêtes de congé`,
  CREATE_TIME_OFF_REQUEST: `Demander un congé`,
  VIEW_MY_TIME_OFF_REQUESTS: `Voir mes requêtes de congé`,
  MY_MESSAGES: `Mes messages`,
  UNREAD_SHIFT_OFFER: `{{ count }} non lue`,
  UNREAD_SHIFT_OFFER_other: `{{ count }} non lues`,
  UNREAD_BULLETIN: `{{ count }} non lu`,
  UNREAD_BULLETIN_other: `{{ count }} non lus`,
  UNREAD_LOADING: `Chargement...`,
  VIEW_BULLETINS_AND_OTHER_MESSAGES: `Voir les annonces affichées sur le babillard`,
  VIEW_MY_MESSAGES: `Voir mes messages`,
  MY_SHIFT_OFFERS: `Mes offres de quarts de travail`,
  VIEW_SHIFTS_CURRENTLY_OFFERED: `Voir les quarts de travail qui sont actuellement offerts`,
  VIEW_MY_OFFERS: `Voir mes offres de quarts de travail`,
  NO_APP_ACCESS: `Vous n'avez pas accès aux modules de cette page.`,
  NO_APP_ACCESS_MISTAKE: `Si vous pensez que c'est une erreur, veuillez contacter votre gestionnaire.`,
  BULLETIN_ALERT: `Vous avez {{unreadBulletinCount}} message non lu!`,
  BULLETIN_ALERT_other: `Vous avez {{unreadBulletinCount}} messages non lus!`,
  help: {
    EMPLOYEEHOME: {
      TITLE: `Besoin d'aide? À la recherche de quelque chose?`,
      DESCRIPTION: `Le centre d'aide est là pour vous aider. Vous y trouverez des tutoriels sur la façon d'utiliser l'application et plus encore.`,
      LINK: `Accéder au centre d'aide`
    }
  },
  NEWBULLETIN_MODAL: {
    TITLE: `Messages non lus`,
    SUMMARY: ``
  }
}
